import React, { useEffect } from "react"
import SEO from "../components/SEO"
import LegalPages from "../components/LegalPages"

function CookiePolicy() {
  useEffect(() => {
    const script = document.createElement("script")
    script.id = "termly-jssdk"
    script.src = "https://app.termly.io/embed-policy.min.js"
    if (!document.getElementById("termly-jssdk")) {
      document.body.appendChild(script)
    }
    return () => {
      const existing = document.getElementById("termly-jssdk")
      if (existing) existing.remove()
    }
  }, [])

  return (
    <>
      <SEO
        title="Cookie Policy - Filmustage"
        description="Cookie Policy for Filmustage"
      />

      <LegalPages>
        <div className="postBody text-lg text-gray-400">
          <div className="mb-8">
            <h1 className="h2 mb-4">Cookie Policy</h1>
          </div>

          <section>
            <div
              name="termly-embed"
              data-id="636f3f84-fa98-471d-900b-c9294f714f7f"
            ></div>
          </section>
        </div>
      </LegalPages>
    </>
  )
}

export default CookiePolicy
